import { OrganizationReportUsageAndAccessEntity } from '../entities/';
import { authResource } from './Auth';
import { schema } from '@data-client/rest';
export const OrganizationReportUsageAndAccessResource = authResource({
    path: '/organizations/:organizationId/reports/usageandaccess/:usageAndAccessId?',
    searchParams: {},
    schema: OrganizationReportUsageAndAccessEntity
}).extend('getList', {
    schema: {
        counts: new schema.Collection([OrganizationReportUsageAndAccessEntity]),
        items: new schema.Collection([OrganizationReportUsageAndAccessEntity])
    }
});
